/* ============================================================
   HORCERY — App UI showcase: pinned focus-scroll.
   The section locks in when it crosses screen-centre, then each
   gesture advances the focus: the active phone grows, the others
   shrink + dim. Mirrors the editorial pin (gesture-gated, one step
   per gesture, an extra notch to release at each end).
   Desktop + motion only. No-JS / reduced-motion / <990px → static grid.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DWELL = 560;        // ms lock after a step (a phone holds before the next)
  var ENGAGE_LOCK = 460;  // ms lock while the entry snap settles
  var TOUCH_STEP = 48;

  function wide() { return window.innerWidth >= 990; }

  function initAppUi(section) {
    if (!section || section.__hzInit) return;
    var items = Array.prototype.slice.call(section.querySelectorAll('[data-hz-appui-item]'));
    if (items.length < 2) return;
    if (reduce) return;                       // reduced motion → static grid
    return;                                   // Horcery: app-ui kept STATIC — pinned scroll-jack disabled (was trapping scroll)
    section.__hzInit = true;
    section.setAttribute('data-hz-scroll', '');

    var idx = 0, engaged = false, locked = false, accum = 0, touchY = null;

    function vh() { return window.innerHeight; }
    function wheelStep() { return Math.max(90, vh() * 0.22); }

    function setActive(i) {
      i = Math.min(Math.max(i, 0), items.length - 1);
      idx = i;
      for (var k = 0; k < items.length; k++) items[k].classList.toggle('is-focus', k === i);
    }
    setActive(0);

    function coversCentre() {
      var r = section.getBoundingClientRect();
      return r.top <= vh() * 0.5 && r.bottom >= vh() * 0.5;
    }
    function snapSmooth() {
      var r = section.getBoundingClientRect();
      if (Math.abs(r.top) > 2) window.scrollTo({ top: window.scrollY + r.top, behavior: 'smooth' });
    }
    function alignInstant() {
      var r = section.getBoundingClientRect();
      if (Math.abs(r.top) > 1) window.scrollTo(0, window.scrollY + r.top);
    }
    function atEnd(dir) { return (dir > 0 && idx >= items.length - 1) || (dir < 0 && idx <= 0); }

    // Returns true when the gesture is consumed (page stays frozen).
    function handle(delta, stepThreshold) {
      if (!wide() || !coversCentre()) { engaged = false; return false; }
      var dir = delta > 0 ? 1 : -1;
      if (!engaged && atEnd(dir)) return false;                 // released at an end, pushing out → let page scroll
      if (!engaged) {                                           // pin + snap into place
        engaged = true; accum = 0;
        snapSmooth();
        locked = true;
        setTimeout(function () { locked = false; alignInstant(); }, ENGAGE_LOCK);
        return true;
      }
      if (locked) { accum = 0; return true; }                  // absorb momentum during snap / dwell
      if (atEnd(dir)) {                                         // extra held notch at each end
        accum += delta;
        if (Math.abs(accum) >= stepThreshold) { accum = 0; engaged = false; return false; }
        return true;
      }
      accum += delta;
      if (Math.abs(accum) >= stepThreshold) {                  // one gesture = one focus step
        accum = 0;
        setActive(idx + dir);
        locked = true;
        setTimeout(function () { locked = false; }, DWELL);
        alignInstant();
      }
      return true;
    }

    function onWheel(e) { if (handle(e.deltaY, wheelStep())) e.preventDefault(); }
    function onTouchStart(e) { touchY = e.touches[0].clientY; }
    function onTouchMove(e) {
      if (touchY === null) return;
      var dy = touchY - e.touches[0].clientY;
      touchY = e.touches[0].clientY;
      if (Math.abs(dy) < 2) return;
      if (handle(dy * 2.2, TOUCH_STEP)) e.preventDefault();
    }
    function onTouchEnd() { touchY = null; }
    function onKey(e) {
      if (!wide() || !coversCentre()) return;
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { if (handle(wheelStep(), wheelStep())) e.preventDefault(); }
      else if (e.key === 'ArrowUp' || e.key === 'PageUp') { if (handle(-wheelStep(), wheelStep())) e.preventDefault(); }
    }

    window.addEventListener('wheel', onWheel, { passive: false });
    window.addEventListener('touchstart', onTouchStart, { passive: true });
    window.addEventListener('touchmove', onTouchMove, { passive: false });
    window.addEventListener('touchend', onTouchEnd, { passive: true });
    section.setAttribute('tabindex', '-1');
    window.addEventListener('keydown', onKey);

    section.__hzCleanup = function () {
      window.removeEventListener('wheel', onWheel);
      window.removeEventListener('touchstart', onTouchStart);
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
      window.removeEventListener('keydown', onKey);
    };
  }

  function teardown(el) {
    if (!el) return;
    if (el.__hzCleanup) { el.__hzCleanup(); el.__hzCleanup = null; }
    el.__hzInit = false;
    el.removeAttribute('data-hz-scroll');
  }

  function initAll() { document.querySelectorAll('[data-hz-app-ui]').forEach(initAppUi); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-hz-app-ui]');
    if (el) { teardown(el); initAppUi(el); }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-hz-app-ui]');
    if (el) teardown(el);
  });
})();
